import { useEffect, useState } from 'react';
import api from '../services/ApiService';
import { isPublicRegistrationEnabled } from '../services/api/clientConfig';

/** Default to invitation access until a fresh server policy explicitly opens signup. */
export function useRegistrationPolicy(active = true) {
  const [publicSignup, setPublicSignup] = useState(false);
  const [revision, setRevision] = useState(0);
  useEffect(() => {
    if (!active) return;
    let current = true;
    setPublicSignup(false);
    void (async () => {
      try {
        const config = await api.getClientConfig();
        if (current) setPublicSignup(isPublicRegistrationEnabled(config));
      } catch { if (current) setPublicSignup(false); }
    })();
    return () => { current = false; };
  }, [active, revision]);
  return { publicSignup, refreshPolicy: () => setRevision(value => value + 1) };
}
